export const DATA = [
	{
		img: "2",
		title: "IT & Engineering",
		description: "Elit irure laboris tempor veniam velit exercitation",
		count: 43,
		members: [
			{
				name: "Lizzie Wells",
				img: "6",
			},
			{
				name: "Susie Kelley",
				img: "7",
			},
			{
				name: "Dora Norris",
				img: "8",
			},
			{
				name: "Ola Briggs",
				img: "9",
			},
			{
				name: "Jesse Vega",
				img: "10",
			},
			{
				name: "Gabriel Richards",
				img: "11",
			},
		],
	},
	{
		img: "3",
		title: "UI and Design",
		description: "Voluptate laboris fugiat fugiat laboris exercitation",
		count: 20,
		members: [
			{
				name: "Chase Chavez",
				img: "2",
			},
			{
				name: "Beatrice Tyler",
				img: "10",
			},
			{
				name: "Lura Willis",
				img: "11",
			},
			{
				name: "Arthur Stevens",
				img: "3",
			},
			{
				name: "Tillie Woods",
				img: "9",
			},
			{
				name: "Howard Holland",
				img: "4",
			},
		],
	},
	{
		img: "4",
		title: "Sales & Marketing",
		description: "Cillum ipsumad pariatur proident minim eiusmod",
		count: 32,
		members: [
			{
				name: "Lucile Lamb",
				img: "3",
			},
			{
				name: "Josie Day",
				img: "5",
			},
			{
				name: "Ivan Higgins",
				img: "1",
			},
			{
				name: "Katharine Gill",
				img: "2",
			},
			{
				name: "Amy Russell",
				img: "16",
			},
			{
				name: "Blake Allison",
				img: "15",
			},
		],
	},
	{
		img: "6",
		title: "Search Engine Optimization",
		description: "Labore irure quiorem mollit ullamco anims",
		count: 25,
		members: [
			{
				name: "Mina Daniels",
				img: "4",
			},
			{
				name: "Francis Duncan",
				img: "10",
			},
			{
				name: "Chad Brock",
				img: "9",
			},
			{
				name: "Raymond Morales",
				img: "14",
			},
			{
				name: "Nettie Floyd",
				img: "11",
			},
			{
				name: "Clarence Bass",
				img: "7",
			},
		],
	},
	{
		img: "11",
		title: "Human Resource Management",
		description: "Sit mollit laborisea occaecat deserunt consectetur",
		count: 24,
		members: [
			{
				name: "Ruby Ramsey",
				img: "12",
			},
			{
				name: "Nettie Becker",
				img: "13",
			},
			{
				name: "Kathryn Spencer",
				img: "14",
			},
			{
				name: "Ronald Delgado",
				img: "15",
			},
			{
				name: "Stella Ramos",
				img: "16",
			},
			{
				name: "John Jefferson",
				img: "12",
			},
		],
	},
	{
		img: "9",
		title: "Research and Development",
		description: "Nulla labore excepteur suntelit nostrud labore aliqua",
		count: 10,
		members: [
			{
				name: "Georgia Ruiz",
				img: "6",
			},
			{
				name: "Peter Warner",
				img: "7",
			},
			{
				name: "Virginia Hansen",
				img: "8",
			},
			{
				name: "Ora Hughes",
				img: "9",
			},
			{
				name: "Mathilda Ruiz",
				img: "10",
			},
		],
	},
];
